import {AaSequenceSpecifier} from 'analyses/aa-sequence-alignment/util/AaSequenceAlignmentConstants';
import {Permissions} from 'auth/PermissionConstants';
import {AaSequenceSummary, AaSequenceServerResponse} from 'molbio/aa-sequences/util/AaSequenceConstants';

/**
 * Given a protein model, create a protein specifier (which specifies a row to use in a protein
 * alignment) that specifies that that protein should be used.
 */
export default function specifierForAaSequence(
  protein: (AaSequenceSummary | AaSequenceServerResponse) & {permissions: Permissions}
): AaSequenceSpecifier {
  return {
    id: protein.id,
    name: protein.name,
    canBeTemplate: Boolean(protein.permissions.polymerFeaturesEditable),
  };
}
